import { Component, OnInit, TemplateRef } from "@angular/core";
import { Socket } from "ngx-socket-io";
import { ToastrService } from "ngx-toastr";
import { UsersService } from "../services/users.service";
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
@Component({
  selector: 'app-gatewaylist',
  templateUrl: './gatewaylist.component.html',
  styleUrls: ['./gatewaylist.component.scss']
})
export class GatewaylistComponent implements OnInit {
  userDetails: any;
  transactions: any[] = [];
  allTransactions: any[] = [];
  selectedTransaction: any = null;
  selectedFile: File | null = null;
  imageUrl: string | ArrayBuffer | null = null;
  img_size: any;
  modalRef: BsModalRef;
  activeTab: string = "gateway";
  isLoading: boolean = false;
  gatewayTypes = ["UPI(A)", "GATEWAY", "TRIPAY"];
  constructor(public socket: Socket,
    private toastr: ToastrService,
    private modalService: BsModalService,
    public httpClient: UsersService) {
    this.userDetails = JSON.parse(sessionStorage.getItem("userDetails"));
  }

  ngOnInit(): void {
    this.getTransactionsByDate();
  }

  setTab(tab: string) {
    this.activeTab = tab;
    this.getTransactionsByDate();
  }
getTransactionsByDate() {

  this.isLoading = true; // ✅ loader start

  const data = { user_id: this.userDetails.details._id, type: "1" };

  this.httpClient.walletPost("transactions", data).subscribe(
    (res: any) => {

      this.isLoading = false; // ✅ loader stop

      if (res.success) {
        const responseData = res.data || [];
        this.allTransactions = responseData;
        this.applyFilter();
      } else {
        this.transactions = [];
      }
    },
    (error) => {
      this.isLoading = false; // ✅ error में भी stop
      console.error("API error:", error);
      this.transactions = [];
    }
  );
}

  applyFilter() {
    if (this.activeTab === "gateway") {
      this.transactions = this.allTransactions.filter(
        (item: any) =>
          item.type === "Deposit" &&
          this.gatewayTypes.includes(item?.paymentType?.toUpperCase()),
      );
    } else {
      this.transactions = this.allTransactions.filter(
        (item: any) =>
          item.type === "Deposit" &&
          !this.gatewayTypes.includes(item?.paymentType?.toUpperCase()),
      );
    }
  }
  openModal(item: any, showimgModal: TemplateRef<any>) {
    this.selectedTransaction = item;
    this.modalRef = this.modalService.show(
      showimgModal,
      Object.assign({}, { class: 'success modal-lg' })
    );
  }

  onFileChange(event: any) {
    this.selectedFile = event.target.files[0];
    let a = event.target.files[0];
    let size: any = a.size / 1000000;
    this.img_size = parseFloat(size).toFixed(2);
    const reader = new FileReader();
    reader.onload = (e) => {
      this.imageUrl = e.target?.result;
    };
    reader.readAsDataURL(this.selectedFile);
  }

  submit() {
    if (!this.imageUrl) {
      this.toastr.error("Please select screenshot");
      return;
    } else {
      var data = new FormData();
      data.append("user_id", this.userDetails.details._id);
      data.append("image", this.selectedFile);
      data.append("payment_id", this.selectedTransaction?._id);

      this.httpClient
        .walletPost("update-gateway-deposit-request", data)
        .subscribe(
          (response: any) => {

            if (response.success) {
              this.toastr.success(response.message);
              this.getTransactionsByDate();
              this.selectedTransaction = null;
              this.cancel();
              this.modalRef.hide()
            } else {
              this.toastr.error(response.message);
              this.cancel();
              this.modalRef.hide()
            }
          },
          (error) => {
            this.toastr.error("Something went wrong");
            this.cancel();
            const modalElement: any = document.getElementById("showimgModal");
            const modal = (window as any).bootstrap.Modal.getInstance(
              modalElement,
            );
            this.modalRef.hide()
          },
        );
    }
  }

  cancel() {
     this.modalRef.hide()
    this.selectedTransaction = null;
    this.selectedFile = null;
  }

}

